export enum TOOLTIP_POSITION {
  TOP_LEFT = 'tl',
  TOP = 't',
  TOP_RIGHT = 'tr',
  LEFT = 'l',
  RIGHT = 'r',
  BOTTOM_LEFT = 'bl',
  BOTTOM = 'b',
  BOTTOM_RIGHT = 'br',
}

interface TooltipStartingPositionParams {
  position: `${TOOLTIP_POSITION}`;
  domReact: {
    width: number;
    height: number;
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
  offset: number;
}

export function getTooltipStartingPosition(params: TooltipStartingPositionParams) {
  const { position, domReact, offset } = params;
  const { right, left, width, height, top, bottom } = domReact;

  switch (position) {
    case 'tl':
      return {
        y: top - offset,
        x: left,
      };
    case 't':
      return {
        y: top - offset,
        x: left + width / 2,
      };
    case 'tr':
      return {
        y: top - offset,
        x: right,
      };
    case 'l':
      return {
        y: top + height / 2,
        x: left - offset,
      };
    case 'r':
      return {
        y: top + height / 2,
        x: left + width + offset,
      };
    case 'bl':
      return {
        y: bottom + offset,
        x: left,
      };
    case 'b':
      return {
        y: top + height + offset,
        x: left + width / 2,
      };
    case 'br':
      return {
        y: bottom + offset,
        x: right,
      };
  }
}

export const ADDITIONAL_TRANSFORM: Record<TOOLTIP_POSITION, string> = {
  tl: 'transform -translate-y-full',
  t: 'transform -translate-y-full -translate-x-1/2',
  tr: 'transform -translate-y-full -translate-x-full',
  l: 'transform -translate-y-1/2 -translate-x-full',
  r: 'transform -translate-y-1/2',
  bl: '',
  b: 'transform -translate-x-1/2',
  br: 'transform -translate-x-full',
};
